<template>
  <div class="loading-screen-cover">
    <div id="loading" class="flex flex-col items-center">
      <img
        src="/assets/images/Thyme-Logo-Wordmark-OffWhite.png"
        alt="loading"
      />
      <div
        v-if="showTroubleshooting"
        class="text-nash-neutral000 flex flex-col items-center mt-4 gap-2"
      >
        <p>This is taking a while to load.</p>

        <div class="flex items-center justify-center">
          <template v-if="canHitVpn === false">
            <TIcon icon="exclamationCircle" class="inline text-nash-brick600" />

            <div class="ml-2">
              Cannot hit the API server due a network issue. Please ensure you
              are connected to the VPN and try the instructions
              <a
                class="text-nash-neutral000 font-bold"
                :href="VPN_INSTRUCTIONS_URL"
                >here</a
              >
              prior to reporting a bug.
            </div>
          </template>
          <template v-else-if="canHitVpn">
            <div class="flex items-center">
              <TIcon icon="checkCircle" class="inline text-nash-fern600" />
              <div class="ml-2 italic">
                <p>Confirmed connectivity with the API server.</p>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="italic">
              Automatically testing connectivity with the API server...
            </div>
          </template>
        </div>

        <div
          v-if="canHitVpn && errorMessage"
          class="flex items-center justify-center"
        >
          <TIcon
            icon="exclamationTriangleFilled"
            class="inline text-nash-mustard600"
          />

          <div class="ml-2">{{ errorMessage }}</div>
        </div>
        <p>
          Click
          <a class="text-nash-neutral000 font-bold" :href="THYMEBOX_HELP_URL"
            >here</a
          >
          for more assistance.
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import TIcon from '@thyme/nashville/src/components/icon/TIcon.vue'
import { defineComponent } from 'vue'
import { setup } from './controller'

export default defineComponent({
  components: {
    TIcon,
  },
  props: {
    errorMessage: { type: String, default: '' },
  },
  setup,
})
</script>

<style lang="scss" scoped>
.loading-screen-cover {
  @apply flex items-center content-center justify-center;
  @apply h-screen w-screen fixed top-0 left-0 z-50;
  @apply bg-nash-purple600;
}

#loading img {
  animation: 0.8s ease-in-out 0s infinite alternate breathe;
  transition: opacity 1s;
  width: 100px;
}

@keyframes breathe {
  from {
    transform: scale(1);
  }

  to {
    transform: scale(0.9);
  }
}
</style>
